import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Quote = class Quote extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-quote';
	}

	constructor(element) {
		super(element);
	}

	setVars() {
		this.$tweetBtn = this.$element.find('.fa-quote__twitter');
		this.$tweenAnchor = this.$tweetBtn.find('a');
	}

	initTwitter() {
		if (this.$body.hasClass('live-mode') && this.$tweetBtn) {
			this.$tweenAnchor.addClass('twitter-share-button');

			//window.twttr.widgets.load();
		}
	}

	render() {
		this.setVars();
		this.initTwitter();
	}
};

/** To show Testimonials Quotes count */
$(function () {
	let allQuotes = $(this).find(".cw-new-theme .fa-video-carousel .carousel-container").find('.fa-quote');
	let quoteCountTriangle  = $('.cw-new-theme').find(".quote-count-triangle-down p");
	let totalCountTriangle  = $('.cw-new-theme').find(".quote-count-triangle-up p");

	function quoteCountFn() {
		let currentIndex = 0;
		let count = 0;
		let totalCount = 0;
		allQuotes.each(function() {
			totalCount++;
			if($(this).hasClass('slick-active')) {
				currentIndex = $(this).data('slick-index')+1;
			}
			if($(this).hasClass('slick-cloned')) {
				count++;
			}
		})
		quoteCountTriangle.text(`${currentIndex}`);
		totalCountTriangle.text(`${totalCount - count}`);
	}
	
	$('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel').on('afterChange',function() {
		quoteCountFn();
	})

	$('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel').on('swipe',function() {
		quoteCountFn();
	})

	quoteCountFn();

	$('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel .carousel .slick-next').click(function() {
		console.log("function called");
		quoteCountFn();
	})
	$('.cw-new-theme  .fa-video-carousel .carousel-container .fa-carousel .carousel .slick-prev').click(function() {
		console.log("function called");
		quoteCountFn();
	})
})


// WEBPACK FOOTER //
// ./components/quote/scripts/quote.js